import Parse from 'parse';
import Configs from './Configs';

const parseInitialize = Configs.parseInitialize;
const parseServerURL = Configs.parseServerURL;
Parse.initialize(parseInitialize);
Parse.serverURL = parseServerURL;

export default Parse;